import { get, post } from './http-calls';

export const postTCardsCloseDay = async (data) => {
    let res = await post(`TCards/TCards_CloseDay?Date=${data}`, {}, { useAuthToken: true });
    return res;
};

export const postTCardsCloseDayByCalID = async (CalID) => {
    let res = await post(`TCards/TCards_CloseDay?TCardCalendarID=${CalID}`, {}, { useAuthToken: true });
    return res;
};
